import "../../style.css";
import { useState, useEffect, useCallback, useMemo } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { RxCross2 } from "react-icons/rx";
import { MdClear } from 'react-icons/md';
import {
  fetchBranchData,
  initBranchState,
} from "../../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../../redux/slices/departmentSlice";
import {
  fetchData,
  initShiftState,
} from "../../../../redux/slices/shiftsSlice";
import {
  commonSaveData,
  commonSaveDataOne,
  initCommonState,
} from "../../../../redux/slices/commonSlice";

import {
  saveAttendance,
  initAttendanceState,
} from "../../../../redux/slices/attendanceSlice";

import {
  calculateEarnedSalaryPath,
  addAdvancePath,
} from "../../../../services/config";
import {
  getCapitalizeWord,
  getInitials,
  getInitialColor,
  formatIndianAmountType
} from "../../../../services/commonServices";
import CustomPagination from "../../../../components/CustomPagination";
import TableSkeleton from "../../../../components/table/TableSkeleton.js";

import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Widgets from "../../../../components/Widgets/index.js";

import { HasPermission } from "../../../../services/hasPermission.js";

const Advance = () => {
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user_data")) || {};

  const branchState = useSelector((state) => state.branch);
  const departState = useSelector((state) => state.department);
  const shiftState = useSelector((state) => state.shift);
  const commonStore = useSelector((state) => state.common);
  const attendanceStore = useSelector((state) => state.attendance);

  const getData = useCallback(() => {
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchData(user.user_id));
  }, []);

  const [advancePayrollList, setAdvancePayrollList] = useState([]);
  const [advancePayrollListOne, setAdvancePayrollListOne] = useState([]);
  const [branch, setBranch] = useState([]);
  const [depart, setDepart] = useState([]);
  const [shift, setShift] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [startLeavingDate, setStartLeavingDate] = useState(null);
  const [endLeavingDate, setEndLeavingDate] = useState(null);

  const [paymentUser, setPaymentUser] = useState({});

  const [maxMonth, setMaxMonth] = useState("");

  const [state, setState] = useState({
    userId: user.user_id,
    selectedDate: "",
    branchId: "",
    shiftId: "",
  });

  const [searchQuery, setSearchQuery] = useState("");

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const date = new Date();
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "long" });
  const month__ = String(date.getMonth() + 1).padStart(2, "0");

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    setMaxMonth(`${year}-${month}`);
    setState((prev) => ({
      ...prev,
      selectedDate: `${year}-${month}`,
    }));
    submitDataForAdvance(`${year}-${month}`, state.branchId, state.shiftId);
  }, []);

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      setBranch(branchState.brnGetData);
      dispatch(initBranchState());
    }

    if (departState.depGetSuccess) {
      setDepart(departState.depGetData);
      dispatch(initDepartState());
    }

    if (shiftState.shiftGetSuccess) {
      setShift(shiftState.shiftGetData);
      dispatch(initShiftState());
    }

    if (commonStore.commonSuccess) {
      if (searchQuery != "") {
        searchEmployees(searchQuery, commonStore.commonData?.staffDetails)
      } else {
        setAdvancePayrollList(commonStore.commonData?.staffDetails);
        setAdvancePayrollListOne(commonStore.commonData?.staffDetails);
        dispatch(initCommonState());
        getData();
      }
    }

    if (attendanceStore.attendanceSuccess) {
      setIsSidebar(false);
      setPaymentUser({});
      setPayState((pre) => ({
        ...pre,
        amount: "",
        paymentDate: "",
        notes: "",
      }));
      toast.success(attendanceStore.attendanceMessage);
      submitDataForAdvance(`${year}-${month__}`, state.branchId, state.shiftId);
      dispatch(initAttendanceState());
    }

    if (attendanceStore.attendanceError) {
      setIsSidebar(false);
      setPaymentUser({});
      setPayState((pre) => ({
        ...pre,
        amount: "",
        paymentDate: "",
        notes: "",
      }));
      toast.error(attendanceStore.attendanceMessage);
      dispatch(initAttendanceState());
    }
  }, [
    branchState,
    departState,
    shiftState,
    commonStore,
    attendanceStore,
    dispatch,
  ]);

  const handleClickFromD1 = (id) => {
    document.getElementById(id).click();
  };

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState("xs");

  const [isSidebar, setIsSidebar] = useState(false);

  const handlePayment = (type) => {
    if (type == "offline") {
      setIsActive(false);
      setIsSidebar(true);
    } else {
      setIsActive(false);
    }
  };

  const [isActive, setIsActive] = useState(false);

  const payOption = (data) => {
    setPaymentUser(data);
    setIsActive(true);
  };

  const [payState, setPayState] = useState({
    amount: "",
    paymentDate: "",
    notes: "",
  });

  const handlePaymentChange = ({ target: { name, value } }) => {
    setPayState((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  const savePaymentSubmit = (e) => {
    const data = {
      path: addAdvancePath,
      data: {
        userId: user.user_id,
        staffId: paymentUser.staffId,
        amount: payState.amount,
        paymentDate: payState.paymentDate,
        notes: payState.notes,
      },
    };

    dispatch(saveAttendance(data));
  };

  // Calculate total CTC
  const totalCTC = useMemo(() => {
    if (!Array.isArray(advancePayrollList) || advancePayrollList.length === 0) {
      return 0;
    }
    
    return advancePayrollList.reduce((total, item) => {
      const ctcValue = item.CostToCompany || item.ctc || 0;
      return total + (parseFloat(ctcValue) || 0);
    }, 0);
  }, [advancePayrollList]);

  // Calculate total advance amount
  const totalAdvance = useMemo(() => {
    if (!Array.isArray(advancePayrollList) || advancePayrollList.length === 0) {
      return 0;
    }
    
    return advancePayrollList.reduce((total, item) => {
      const advanceValue = parseFloat(
        item.salaryCountDays?.advanceAmount || 
        0
      ) || 0;
      return total + advanceValue;
    }, 0);
  }, [advancePayrollList]);

  const columns = useMemo(
    () => [
      {
        headerName: "SNo",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 60,
        pinned: "left",
      },
      {
        headerName: "Employee ID",
        field: "employeeId",
        pinned: "left",
        width: 120,
      },
      {
        headerName: "Name",
        filter: true,
        pinned: "left",
        height: "60px",
        width: "350px",
        cellRenderer: (row) => {
          return (
            <span
              className="table-link d-flex align-items-center justify-content-start gap-2"
            >
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  border: "1px solid lightgray",
                  borderRadius: "50%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: getInitialColor(row.data.staffName),
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                {getInitials(row.data.staffName)}
              </div>
              {getCapitalizeWord(row.data.staffName)}
            </span>
          );
        },
      },
      {
        headerName: "CTC",
        field: "CostToCompany",
        filter: true,
        width: "140",
        cellRenderer: (rowData) => {
          return rowData.data.CostToCompany ? formatIndianAmountType(rowData.data.CostToCompany) : "-"
        }
      },
      {
        headerName: "Advance Paid",
        filter: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "140",
        cellRenderer: (rowData) => {
          return (
            <span>
              {rowData.data.salaryCountDays?.advanceAmount
                ? formatIndianAmountType(rowData.data.salaryCountDays.advanceAmount)
                : "-"}
            </span>
          );
        },
      },

      {
        headerName: "Bank Verified",
        filter: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "140",
        cellRenderer: (rowData) => {
          return <span>{"-"}</span>;
        },
        flex: 1,
      },
      {
        headerName: "Actions",
        popup: true,
        cellRenderer: (row) => {
          return HasPermission("Advance", "create") ? (
            <span
              onClick={() => payOption(row.data)}
              style={{ color: "#8234db", cursor: "pointer" }}
            >
              Pay Advance
            </span>
          ) : (
            "-"
          );
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: "200px",
      },
    ],
    []
  );

  const submitDataForAdvance = useCallback((date, branchId, shiftId) => {
    if (date) {
      const data = {
        path: calculateEarnedSalaryPath,
        data: {
          userId: user.user_id,
          selectedDate: `${date}-01`,
          branchId: branchId,
          shiftId: shiftId,
        },
      };
      dispatch(commonSaveData(data));
    }
  }, []);

  const handelChange = ({ target: { name, value } }) => {
    setState((pre) => ({
      ...pre,
      [name]: value,
    }));
    if (name == "selectedDate") {
      submitDataForAdvance(value, state.branchId, state.shiftId);
      return;
    }
    if (name == "branchId") {
      submitDataForAdvance(state.selectedDate, value, state.shiftId);
      return;
    }
    if (name == "shiftId") {
      submitDataForAdvance(state.selectedDate, state.branchId, value);
      return;
    }
  };

  const searchEmployees = (value, dataList) => {
    setSearchQuery(value);
    const filteredEmployees = dataList.filter((v) =>
      v.staffName.toLowerCase().includes(value.toLowerCase()) ||
      (v.employeeId && v.employeeId.toLowerCase().includes(value.toLowerCase()))
    );
    setAdvancePayrollList(filteredEmployees);
    setAdvancePayrollListOne(dataList)
  };

  const date_1 = new Date();
  const year_1 = date_1.getFullYear();
  const month_1 = String(date_1.getMonth() + 1).padStart(2, "0");

  const clearFilter = () => {
    setSearchQuery("")
    setState((pre) => ({
      ...pre,
      selectedDate: `${year_1}-${month_1}`,
      branchId: "",
      shiftId: "",
      departmentId: "",
    }))
    submitDataForAdvance(`${year_1}-${month_1}`, "", "");
  };

  // HTML ELEMENT RENDERING ---------------------------------------------------
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <div
        style={{
          position: "fixed",
          width: "calc(100% - 20px)",
          height: "100%",
        }}
        className="mt-2"
      >
        <Widgets
          body={
            <Row>
              <Col sm="12">
                <div className="d-flex align-items-center justify-content-start gap-3 px-3">
                  <Form.Group>
                    <Form.Control
                      className="universal-input"
                      placeholder="Search"
                      style={{ width: "450px" }}
                      value={searchQuery}
                      onChange={(e) => searchEmployees(e.target.value, advancePayrollListOne)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Control
                      type="month"
                      name="selectedDate"
                      value={state.selectedDate}
                      onChange={handelChange}
                      max={maxMonth}
                      className="universal-input"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Select
                      name="branchId"
                      value={state.branchId}
                      onChange={handelChange}
                      className="universal-input"
                    >
                      <option value="">{state.branchId ? "All Branches" : "Select Branch"}</option>
                      {branch.map((row, idx) => {
                        return (
                          <option value={row.branchId} key={idx}>
                            {row.branch_name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group>
                    <Form.Select
                      name="shiftId"
                      value={state.shiftId}
                      onChange={handelChange}
                      className="universal-input"
                      style={{width: "180px"}}
                    >
                      <option value="">{state.shiftId ? "All Shift" : "Select Shift"}</option>
                      {shift.map((row, idx) => {
                        return (
                          <option value={row.shiftId} key={idx}>
                            {row.shiftName}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group>
                    {
                      (
                        searchQuery ||
                        state.selectedDate != `${year_1}-${month_1}` ||
                        state.shiftId ||
                        state.departmentId ||
                        state.branchId) && <button type="button" className="clear" onClick={clearFilter}>
                        <MdClear /> Clear
                      </button>
                    }
                  </Form.Group>
                </div>

                <div
                  className="ag-theme-quartz custom-grid"
                  style={{
                    height: "calc(100vh - 280px)",
                    width: "100%",
                    padding: "10px 20px",
                    paddingRight: "40px",
                  }}
                >
                  {commonStore.commonLoading ? (
                    <TableSkeleton />
                  ) : (
                    <AgGridReact
                      rowData={
                        Array.isArray(advancePayrollList) ? advancePayrollList : []
                      }
                      columnDefs={columns}
                      pagination={true}
                      paginationPageSize={paginationPageSize}
                      onGridReady={onGridReady}
                    />
                  )}
                </div>

                <div className="d-flex align-items-center justify-content-between custom-pagination px-4">
                  {gridApi && <CustomPagination gridApi={gridApi} />}
                  <div className="d-flex align-items-center justify-content-start gap-3 color-white">
                    <div className="d-flex flex-column align-items-start">
                      <div>Total CTC: &#8377; {formatIndianAmountType(totalCTC)}</div>
                      {/* <div>Total Advance: &#8377; {formatIndianAmountType(totalAdvance)}</div> */}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          }
        />

        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={isActive}
          onClose={() => setIsActive(false)}
          style={{ overflow: "visible" }}
          className="dark-bg-color"
        >
          <DialogTitle
            className="dialog-title"
            style={{ fontSize: "16px", fontWeight: "600" }}
          >
            Select Payment Option
          </DialogTitle>
          <DialogContent
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 50px",
              overflow: "visible",
            }}
            disableEnforceFocus
            disableAutoFocus
          >
            <Form.Group style={{ width: "100%", marginTop: "30px" }}>
              <ul className="payment-option">
                <li
                  className="color-white"
                  onClick={() => handlePayment("online")}
                >
                  Pay Online
                </li>
                <li
                  className="color-white"
                  onClick={() => handlePayment("offline")}
                >
                  Save Payment
                </li>
              </ul>
            </Form.Group>
          </DialogContent>
        </Dialog>

        <Dialog
          open={isSidebar}
          keepMounted
          onClose={() => setIsSidebar(false)}
          maxWidth="xs"
          fullWidth
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="dark-bg-color"
        >
          <DialogTitle className="dialog-title">
            <div className="dialog-title-icon">
              <span className="close-icon" onClick={() => setIsSidebar(false)}>
                X
              </span>
              <span className="title">Pay Advance</span>
            </div>
            <button className="universal-btn" onClick={savePaymentSubmit}>
              Add
            </button>
          </DialogTitle>
          <DialogContent className="pure-dark-bg-color">
            <Form className="mt-3 px-2">
              <Form.Group
                className="mt-4 mb-3"
              >
                <Form.Label
                  style={{
                    textWrap: "nowrap",
                    fontSize: "14px",
                    marginRight: "50px",
                  }}
                >
                  Amount
                </Form.Label>

                <Form.Control
                  value={payState.amount}
                  name="amount"
                  onChange={handlePaymentChange}
                  placeholder="Amount"
                  className="universal-input"
                />
              </Form.Group>

              <Form.Group
                className="mb-3"
              >
                <Form.Label
                  style={{
                    textWrap: "nowrap",
                    fontSize: "14px",
                    marginRight: "10px",
                  }}
                >
                  Payment Date
                </Form.Label>

                <Form.Control
                  type="date"
                  max={new Date().toISOString().split("T")[0]}
                  value={payState.paymentDate}
                  name="paymentDate"
                  onChange={handlePaymentChange}
                  className="universal-input"
                />
              </Form.Group>

              <Form.Group
                className="mb-3"
              >
                <Form.Label
                  style={{
                    textWrap: "nowrap",
                    fontSize: "14px",
                    marginRight: "60px",
                  }}
                >
                  Notes
                </Form.Label>

                <Form.Control
                  as="textarea"
                  style={{
                    height: "100px",
                    backgroundColor: "transparent",
                    color: "white",
                  }}
                  placeholder="Notes"
                  value={payState.notes}
                  name="notes"
                  onChange={handlePaymentChange}
                  className="color-white"
                />
              </Form.Group>
            </Form>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default Advance;